import { inject, Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { FocusableComponent } from '@shareview/shared/focusable';
import { take, tap } from 'rxjs';
import {
  YoutubeVideoPlayerDialogComponent
} from '../../dialogs/youtube-video-player-dialog/youtube-video-player-dialog.component';
import { YoutubeVideoPlayerDialogData } from '../../types/youtube-video-player-dialog-data';

@Injectable()
export class YoutubeVideoPlayerService {
  private readonly dialog = inject(MatDialog);
  private _dialogRef?: MatDialogRef<YoutubeVideoPlayerDialogComponent>;

  public open(parent: FocusableComponent, data: YoutubeVideoPlayerDialogData): void {
    if (this._dialogRef) {
      return;
    }

    this._dialogRef = this.dialog.open(YoutubeVideoPlayerDialogComponent, {
      data: data,
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      hasBackdrop: false,
      disableClose: true
    });

    this._dialogRef.afterClosed()
      .pipe(
        take(1),
        tap(() => this.close())
      ).subscribe(() => parent.popFocusableInterceptor());

    parent.pushFocusableInterceptor(this._dialogRef.componentInstance);
  }

  public close() {
    this._dialogRef?.close();
    this._dialogRef = undefined;
  }
}
